import { render, staticRenderFns } from "./Resetpwd.vue?vue&type=template&id=2f1e1e52"
import script from "./Resetpwd.vue?vue&type=script&lang=js"
export * from "./Resetpwd.vue?vue&type=script&lang=js"
import style0 from "./Resetpwd.vue?vue&type=style&index=0&id=2f1e1e52&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports